module.exports = __webpack_public_path__ + "media/top/helpful_info_article_03-2fa659a0.svg";